/** Traductions overlay chargement (FR / AR) */
export const loadingOverlayFr = {
  processing: 'Traitement en cours...'
};

export const loadingOverlayAr = {
  processing: 'جاري المعالجة...'
};
